export default __webpack_public_path__ + "static/header.energietirol.uebersicht-c97fc48fc5716aef1a234a9da917e6f3.png";